import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from '@/App';
import { installApiBridge } from '@/lib/api-bridge';
import { TenantQueryProvider } from '@/lib/query/TenantQueryProvider';
import '@/styles/globals.css';

// Rewrite the app's /api/* calls onto the Laravel API before anything renders.
installApiBridge();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <TenantQueryProvider>
        <App />
      </TenantQueryProvider>
    </BrowserRouter>
  </StrictMode>,
);
